import { UserProperties } from '../../interfaces/userProperties';

import { getAmplitudeInstance } from './getAmplitudeInstance';

export function setUserProperties(properties: UserProperties): void {
  getAmplitudeInstance()?.setUserProperties(properties);
}
